export default "__VITE_ASSET__DtiUMUSI__"